import { render, staticRenderFns } from "./ItemTracking.vue?vue&type=template&id=63a8d978&scoped=true"
import script from "./ItemTracking.vue?vue&type=script&lang=js"
export * from "./ItemTracking.vue?vue&type=script&lang=js"
import style0 from "./ItemTracking.vue?vue&type=style&index=0&id=63a8d978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8d978",
  null
  
)

export default component.exports